<template>
  <div class="price-blurring"
       :class="{
          'is-blurring':isBlurring,
          'inline':inline,
          'inline-block':inlineBlock,
        }"
       :style="[customStyle,isBlurring?blurringStyle:'',]"
       @click.stop>
    <span class="price-blurring--box" v-popover:popover @click="clickPrice">
      <slot>
        <span class="price-blurring--currency" v-if="currency && price !== '单询'">{{currency}}</span>
        <span class="price-blurring--price" :style="[customPriceStyle]" v-if="price">
          <template v-if="isBlurring">****</template>
          <template v-else-if="isObject(price)">
            <div class="color-primary">{{ price.discountsPrice }}</div>
            <div class="table-origin-price">{{ price.originPrice }}</div>
          </template>
          <template v-else>{{ price }}</template>
        </span>
        <span class="price-blurring--unit" v-if="unit && !isBlurring && price !== '单询'">/{{unit}}</span>
      </slot>
    </span>



    <el-popover
      :disabled="!isBlurring"
      ref="popover"
      placement="bottom"
      title=""
      width="184"
      trigger="hover"
      popper-class="popper-price-realName"
    >
      <div class="realName-box">
        <template v-if="!token">
          <img :src="images.iconRegister" class="realName-icon"/>
          <p class="realName-description">
            注册审核成为销售代理即可查看{{ blurInfoText }}
          </p>
          <el-button type="primary" class="realName-btn" size="small" @click="showLogin">立即注册</el-button>
        </template>
        <template v-else>
          <!-- -1 未认证 1：已提交相关资料，审核中 2：认证失败 3：已认证-->
          <!--<span class="">{{realNameStatusMap[realNameState]||realNameState||"-"}}</span>-->
          <template v-if="realNameState === 1">
            <img :src="images.iconCheck" class="realName-icon"/>
            <p class="realName-description">
              平台正在加紧审核您的认证信息，通过后即可查看{{ blurInfoText }}
            </p>
          </template>
          <template v-else-if="realNameState === 2">
            <img :src="images.iconCheck" class="realName-icon"/>
            <p class="realName-description">
              您提交的认证信息审核失败，请重新提交
            </p>
            <el-button type="primary" class="realName-btn" size="small" @click="goRealNamePage">重新认证</el-button>
          </template>
          <template v-else-if="realNameState === 3">
            <img :src="images.iconCheck" class="realName-icon"/>
            <p class="realName-description">
              已认证
            </p>
          </template>
          <template v-else>
            <img :src="images.iconReal" class="realName-icon"/>
            <p class="realName-description">
              认证成为销售代理即可查看{{ blurInfoText }}
            </p>
            <el-button type="primary" class="realName-btn" size="small" @click="goRealNamePage">立即认证</el-button>
          </template>
        </template>
      </div>
    </el-popover>

  </div>
</template>

<script>
import {mapState,mapGetters} from "vuex";
import {isObject} from 'my-tools-kit'
export default {
  name: "priceBlurring",
  props:{
    //币种
    currency:{
      type:String,
      default:"",
    },
    //价格
    price:{
      type:[String,Number,Object],
      default:"-",
    },
    // 计费单位
    unit:{
      type:String,
      default:"",
    },

    inline:Boolean,
    inlineBlock:Boolean,
    blurringStyle:Object,
    customStyle:Object,
    customPriceStyle:Object,
    // blurringFontSize:[String,Number],
    // 价格显示类型，1：不显示  2：显示，默认不显示
    priceDisplayType:[Number,String],
    // 模糊信息名称
    blurInfoText: {
      type: String,
      default: "运价"
    }
  },
  data(){
    const ossPath = this.ossPath;
    return {
      images:{
        iconCheck:ossPath + "/common/priceBlurring/icon_check.png",
        iconReal:ossPath + "/common/priceBlurring/icon_real.png",
        iconRegister:ossPath + "/common/priceBlurring/icon_register.png",
      },
      //是否显示实名认证提示弹窗
      visibleHit: false,
      // 实名认证状态映射 -1 未认证 1：已提交相关资料，审核中 2：认证失败 3：已认证
      realNameStatusMap:{
        "-1":"未认证",
        "1":"已提交相关资料，审核中",
        "2":"认证失败",
        "3":"已认证",
      },
    }
  },
  computed:{
    ...mapGetters(["realNameState","token","realNameType","isInquiryUserSuccess"]),
    ...mapState(['Authorization']),
    // 是否需要模糊
    isBlurring(){
      if(this.priceDisplayType === 2) return false;
      if(!this.token) return true;
      if(this.Authorization.temporaryAuthentication) return false;
      if(this.isInquiryUserSuccess) return false;
      if(this.realNameType === 1 && this.realNameState === 1) return false;
      if(this.realNameType === 6 && this.realNameState === 1) return false;
      if(this.realNameState !== 3) return true;
      return false;
    },
    // realNameState(){ return 1; },
    // blurringStyle(){
    //   if(!this.isBlurring) return {};
    //   let styleObj = {};
    //   if(this.blurringFontSize){
    //     if(typeof this.blurringFontSize === "number" || /^\d+$/.test(`${this.blurringFontSize}`)){
    //       styleObj.fontSize = `${this.blurringFontSize}px`;
    //     }else{
    //       styleObj.fontSize = this.blurringFontSize;
    //     }
    //   }
    //   return styleObj;
    // },
  },
  methods:{
    isObject,
    clickPrice(e){
      if(this.isBlurring) return false;
      this.$emit('priceClick')
      e.stopPropagation();
      e.preventDefault();
    },
    showLogin(){
      return this.$root.Bus.$emit("showDialog", 0)
    },
    goRealNamePage(){
      this.$router.push({
        path:"/index/PersonalCenter/Personalindex/PersonalCenter/accountManage/UserManage",
      })
    },
    replaceText(text = ""){
      text = `${text}`;
      if(text.match("单询")) return text.replace("单询","*");
      return text.replace(/\d+/g,"*");
    },
  },
}
</script>

<style lang="scss">
.popper-price-realName{
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
}
</style>
<style scoped lang="scss">
.price-blurring{
  color: #FF4D01;
}
.inline{
  display: inline;
}
.inline-block{
  display: inline-block;
}
.is-blurring{
  //user-select: none;
  //text-shadow: 0 0 5px rgba(185,57,72,0.5);
  //color: transparent;
}
.realName-box{
  min-height: 60px;
}
.realName-icon{
  display: block;
  margin: 0 auto 10px;
  width: auto;
  max-width: 100%;
  height: 40px;
}
.realName-description{
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  margin-bottom: 10px;
  text-align: center;
  line-height: 1.6;
}
.realName-btn{
  display: block;
  margin: 0 auto;
  min-width: 130px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
}
.table-origin-price {
  color: #999999;
  text-decoration: line-through;
}
</style>



// WEBPACK FOOTER //
// common/priceBlurring/index.vue